import { render, staticRenderFns } from "./bs-container.vue?vue&type=template&id=5ef5f3d6&"
import script from "./bs-container.vue?vue&type=script&lang=ts&"
export * from "./bs-container.vue?vue&type=script&lang=ts&"
import style0 from "./bs-container.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports